import { Currency } from '@/core/currency/interfaces';

const BIF: Currency = {
    name: 'Burundian Franc',
    demonym: 'Burundian',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '108',
    symbol: 'FBu',
    symbolNative: 'FBu',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 2,
    numToBasic: 100,
    code: 'BIF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BIF;
